module.exports = __webpack_public_path__ + "static/media/books.b7dd5bcc.svg";